import "../style/dashboard/Dashboard.css";
import DashboardShipmentCount from "../components/dashboard/DashboardShipmentCount";
import NotificationBar from "../components/sidebar/NotificationBar";
import { Box } from "@mui/system";
import { DynamicTitle } from "../utils/DynamicTitle";
import { useSetRecoilState } from "recoil";
import { emailState, nameState, surnameState } from "../atoms/membership";
import { useEffect, useState } from "react";
import WrapperStyle from "../utils/WrapperStyle";
import ProfileStatus from "../components/dashboard/ProfileStatus";
import SuggestionForm, { SUGGESTION_FORM_ALLOWED_USER_IDS } from "../components/dashboard/SuggestionForm";
// import PageTransition from "../utils/PageTransition";
import { useCookies } from "react-cookie";
import axios from "../api/axios";
import ChangePasswordInfo from "../components/home/ChangePasswordInfo";
import ChangePasswordInfoBigger from "../components/home/ChangePasswordInfoBigger";
import ChangePasswordInfoBiggerSecond from "../components/home/ChangePasswordInfoBiggerSecond";
import ChangePasswordInfoSmall from "../components/home/ChangePasswordInfoSmall";
import NewsModal from "../components/home/NewsModal";
import KurbanBayramiImg from "../img/images/kurban_bayrami.png";

const Dashboard = () => {
  DynamicTitle("Pano | iyziShip");

  const [token] = useCookies(["jwt"]);
  const jwt = token.jwt;
  axios.defaults.headers.common["Authorization"] = `Bearer ${jwt}`;

  const userInfo = JSON.parse(localStorage.getItem("user"));
  // const userStatus = userInfo?.user?.user_member?.status;
  const isAnnouncementAllowed = SUGGESTION_FORM_ALLOWED_USER_IDS.includes(
    Number(userInfo?.user?.id)
  );

  // const setMemberStatusModal = useSetRecoilState(memberStatusModalState);
  const setName = useSetRecoilState(nameState);
  const setSurname = useSetRecoilState(surnameState);
  const setEmail = useSetRecoilState(emailState);

  const [isModalOpen, setIsModalOpen] = useState(true);
  const [isModalOpenBigger, setIsModalOpenBigger] = useState(true);
  const [isModalOpenBiggerSecond, setIsModalOpenBiggerSecond] = useState(true);
  const [isModalOpenSmall, setIsModalOpenSmall] = useState(true);
  const [isHolidayModalOpen, setIsHolidayModalOpen] = useState(true);

  const [isAnnouncementModalOpen, setIsAnnouncementModalOpen] = useState(true);

  const announcementNews = {
    title: "Önemli Duyuru",
    content: [
      "Değerli Müşterimiz,",
      "Son dönemde başta Amerika Birleşik Devletleri ve Avrupa Birliği olmak üzere birçok ülkede gümrük mevzuatında önemli değişiklikler yaşanmaktadır. Bu değişiklikler doğrultusunda DDU ve DDP gönderimlerinde alıcı tarafında oluşan ek masraflar, gümrük tarife numaralarına ilişkin beyan edilen vergi oranları ile gümrük idarelerinin fiili uygulamaları arasındaki tutarsızlıklar, gönderi içeriği ile gümrük tarafından sınıflandırılan içerik arasındaki farklılıklar, alıcı veya gönderici tarafına yansıtılan ve sabit olmayan ek maliyetler ile sürekli dalgalanan yakıt fiyatlarının taşıma maliyetlerine yansıması nedeniyle; panelimizde hesaplanarak sizlere sunulan fiyat teklifleri ile fiili operasyon maliyetleri arasında uzun süredir bir fark oluşmaktadır.",
      "Bugüne kadar bu farkı müşterilerimize yansıtmamak adına azami gayreti gösterdik. Ancak mevcut koşullarda bu yaklaşımı sürdürülebilir bir iş modeli olarak devam ettirmemiz mümkün görünmemektedir.",
      "Bu doğrultuda, fiyat politikamızda belirli ölçüde güncellemeye gitme kararı aldık. Ayrıca, bazı hizmet kalemlerinde önümüzdeki süreçte hizmet sunumuna devam edemeyeceğimizi bilgilerinize sunarız.",
      "Bu güncellemenin sizleri memnun etmeyeceğinin farkındayız; ancak yukarıda belirtilen ve kontrolümüz dışında gelişen koşullar nedeniyle bu adımı atmak zorunda kaldığımızı belirtmek isteriz.",
      "Anlayışınız için teşekkür ederiz."
    ],
  };

  const setAnnouncementModal = (value) => {
    setIsAnnouncementModalOpen(value);
  };
  const holidayNews = {
    title: "15 Temmuz Demokrasi ve Milli Birlik Günü Duyurusu",
    content: [
      "Değerli Üyelerimiz,",
      "15 Temmuz Çarşamba Günü, Demokrasi ve Milli Birlik Günü sebebi ile resmi tatil olacaktır. Bu yüzden operasyonumuza bir gün ara vermek zorunda kalacağız.",
      "16 Temmuz Perşembe günü itibari ile normal çalışma düzenimize kaldığımız yerden devam edeceğiz :)",
      " İyi günler dileriz…"
    ]
  };

  const setHolidayModal = (value) => {
    setIsHolidayModalOpen(value);
  };

  // Profile verisini çek ve localStorage'ı güncelle (izinler için)
  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await axios.get('profile');
        if (response.data?.data) {
          // Mevcut user objesini al
          const currentUser = JSON.parse(localStorage.getItem("user"));

          // User datasını güncelle (izinleri de içerir)
          currentUser.user = response.data.data;

          // LocalStorage'a kaydet
          localStorage.setItem("user", JSON.stringify(currentUser));

          // Recoil state'leri güncelle
          setName(response.data.data.name);
          setSurname(response.data.data.surname);
          setEmail(response.data.data.email);
        }
      } catch (error) {
        console.error("Profile yüklenirken hata:", error);
        // Hata durumunda mevcut verilerle devam et
        setName(userInfo?.user.name);
        setSurname(userInfo?.user.surname);
        setEmail(userInfo?.user.email);
      }
    };

    fetchProfile();
  }, [setName, setSurname, setEmail]);

  // useEffect(() => {
  //   if (Number(userStatus) !== 2) {
  //     setMemberStatusModal(true);
  //   }
  // }, [setMemberStatusModal, userStatus]);

  return (
    <>
      <section className="dashboard">
        <NotificationBar />
        {isAnnouncementAllowed && (
        <NewsModal
          open={isAnnouncementModalOpen}
          setOpen={setAnnouncementModal}
          newsData={announcementNews}
        />
        )}
        {/* <NewsModal
          open={isHolidayModalOpen}
          setOpen={setHolidayModal}
          newsData={holidayNews}
        /> */}
        {/* <ChangePasswordInfo open={isModalOpen} setOpen={setIsModalOpen} /> */}
        {/* <ChangePasswordInfoBigger
          open={isModalOpenBigger}
          setOpen={setIsModalOpenBigger}
        /> */}
        {/* <ChangePasswordInfoBiggerSecond
          open={isModalOpenBiggerSecond}
          setOpen={setIsModalOpenBiggerSecond}
        /> */}
        {/* <ChangePasswordInfoSmall open={isModalOpenSmall} setOpen={setIsModalOpenSmall} /> */}
        {/* <PageTransition> */}
        <ProfileStatus />
        <Box style={WrapperStyle()} className="dashboard-wrapper">
          <DashboardShipmentCount />
        </Box>
        <SuggestionForm />
        {/* </PageTransition> */}
      </section>
    </>
  );
};

export default Dashboard;
